class WishlistProduct extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onAddWishlist);
    this.LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
    this.LOCAL_STORAGE_DELIMITER = ",";
    this.BUTTON_ACTIVE_CLASS = "active";
    this.moveToWishlistInProgress = false;
    this.onAddActiveClass();
    this.WishlistItemCounter();
    this.initToastStyles();
    this.startCartCheck();
    this.initMoveToWishlistListener();
  }

  // Listen for move to wishlist button clicks
  initMoveToWishlistListener() {
    document.addEventListener('click', (e) => {
      if (e.target.matches('.Move-to-wishlist-cart-items') || e.target.closest('.Move-to-wishlist-cart-items')) {
        this.moveToWishlistInProgress = true;
        // Stop checking cart for 3 seconds to allow move to wishlist to complete
        setTimeout(() => {
          this.moveToWishlistInProgress = false;
        }, 3000);
      }
    });
  }

  // Start interval to check cart every second
  startCartCheck() {
    setInterval(() => {
      this.checkCartAndRemoveFromWishlist();
    }, 1000);
  }

  // Check if wishlist products are in cart and remove them
  checkCartAndRemoveFromWishlist() {
    // Skip if move to wishlist is in progress
    if (this.moveToWishlistInProgress) return;
    
    const wishlist = this.getWishlist();
    if (wishlist.length === 0) return;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartProductHandles = cart.items.map(item => {
          return item.product_handle || item.handle;
        }).filter(handle => handle);

        wishlist.forEach(handle => {
          if (cartProductHandles.includes(handle)) {
            // Remove from wishlist
            this.updateWishlist(handle);
            
            // Update counter
            this.WishlistItemCounter();
            
            // Update button states
            const wishlistButtons = document.querySelectorAll(`button[data-product-handle="${handle}"]`);
            wishlistButtons.forEach(button => {
              button.classList.remove(this.BUTTON_ACTIVE_CLASS);
            });
            
            // Update grid if on wishlist page
            const grid = document.querySelector("[grid-wishlist]");
            if (grid) {
              setupGrid(grid);
            }
          }
        });
      })
      .catch(error => {
        // Silently handle errors to avoid console spam
      });
  }

  // Initialize toast notification styles
  initToastStyles() {
    if (!document.getElementById('wishlist-toast-styles')) {
      const style = document.createElement('style');
      style.id = 'wishlist-toast-styles';
      style.textContent = `
        .wishlist-toast {
          position: fixed;
          bottom: 20px;
          left: 50%;
          background: #CAC5C0;
          color: white;
          padding: 12px 20px;
          border-radius: 0px;
          font-size: 14px;
          font-weight: 500;
          z-index: 10000;
          transform: translateX(400px);
          opacity: 0;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          max-width: 300px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        
        .wishlist-toast.show {
          transform: translateX(0);
          opacity: 1;
        }
        
        .wishlist-toast.success {
          background: black;
        }
        
        .wishlist-toast.remove {
          background: black;
        }
        
        .wishlist-toast-icon {
          font-size: 16px;
        }
        
        @media (max-width: 768px) {
          .wishlist-toast {
            right: 10px;
            left: 10px;
            max-width: none;
            transform: translateY(-100px);
          }
          
          .wishlist-toast.show {
            transform: translateY(0);
          }
        }
      `;
      document.head.appendChild(style);
    }
  }

  // Show toast notification
  showToast(message, type = 'success') {
    // Remove any existing toast
    const existingToast = document.querySelector('.wishlist-toast');
    if (existingToast) {
      existingToast.remove();
    }

    // Create new toast
    const toast = document.createElement('div');
    toast.className = `wishlist-toast ${type}`;
    
    const icon = type === 'success' ? '' : '';
    toast.innerHTML = `
      <span class="wishlist-toast-icon">${icon}</span>
      <span>${message}</span>
    `;

    document.body.appendChild(toast);

    // Trigger animation
    setTimeout(() => {
      toast.classList.add('show');
    }, 10);

    // Remove toast after 1 second
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        if (toast.parentNode) {
          toast.remove();
        }
      }, 300);
    }, 1000);
  }

  WishlistItemCounter() {
    let WISHLIST_ITEM_COUNT = document.querySelectorAll(".wishlist__count");
    let wishlist_item_length = this.getWishlist().length;
    if (WISHLIST_ITEM_COUNT) {
      WISHLIST_ITEM_COUNT.forEach((singleItem) => {
        singleItem.innerText = wishlist_item_length;
      });
    }
    
    // Update wishlist page counter
    const wishlistPageCounter = document.querySelector(".wishlist-heading-existswith-wishlist-counts-number");
    if (wishlistPageCounter) {
      wishlistPageCounter.innerText = wishlist_item_length;
    }
  }

  onAddActiveClass() {
    const wishlistAddedButton = this.querySelector("button");
    if (wishlistAddedButton != null) {
      let productHandle = wishlistAddedButton.dataset.productHandle || false;
      if (!productHandle)
        return console.error(
          "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
        );
      if (this.wishlistContains(productHandle))
        wishlistAddedButton.classList.add(this.BUTTON_ACTIVE_CLASS);
    }
  }

  onAddWishlist() {
    const wishlistItem = this.querySelector("button");
    let productHandle = wishlistItem.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );

    // Check if product is currently in wishlist
    const isInWishlist = this.wishlistContains(productHandle);
    
    this.updateWishlist(productHandle);
    this.WishlistItemCounter();

    // Show appropriate toast message
    if (isInWishlist) {
      this.showToast('Removed from wishlist', 'remove');
    } else {
      this.showToast('Added to wishlist', 'success');
    }

    let grid = document.querySelector("[grid-wishlist]") || false;

    if (grid) {
      // On wishlist page - re-render the entire grid
      setupGrid(grid);
    } else {
      // Not on wishlist page - toggle button state with animation
      wishlistItem.classList.add("loading", "adding");
      setTimeout(function () {
        wishlistItem.classList.remove("loading");
        wishlistItem.classList.toggle("active");
      }, 500);

      setTimeout(function () {
        const addingElement = document.querySelector(".adding");
        if (addingElement) {
          addingElement.classList.remove("adding");
        }
      }, 1000);
    }
  }

  getWishlist() {
    let wishlist =
      localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(this.LOCAL_STORAGE_DELIMITER);
    return [];
  }

  setWishlist(array) {
    let wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
    if (array.length)
      localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist;
  }

  updateWishlist(handle) {
    let wishlist = this.getWishlist();
    let indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);
    return this.setWishlist(wishlist);
  }

  wishlistContains(handle) {
    let wishlist = this.getWishlist();
    return wishlist.indexOf(handle) !== -1;
  }
}
customElements.define("wishlist-item", WishlistProduct);

let newWishlistObj = new WishlistProduct();

document.addEventListener("DOMContentLoaded", function () {
  let grid = document.querySelector("[grid-wishlist]") || false;
  if (grid) {
    setupGrid(grid);
  }
});

var setupGrid = function (grid) {
  var wishlist = newWishlistObj.getWishlist();
  var wishlistExistBtn = document.querySelector(".wishlist-page");

  // Get references to empty list elements
  const emptyList = document.querySelector(".wishlist-grid--empty-list");
  const wishlistHeading = document.querySelector(".wishlist-heading-existswith-wishlist-counts");

  if (wishlist.length > 0) {
    wishlistExistBtn.classList.add("wishlist_exists");
    
    // Show the grid and heading, hide empty message
    grid.style.display = "flex";
    
    if (emptyList) {
      emptyList.style.display = "none";
    }
    if (wishlistHeading) {
      wishlistHeading.style.display = "block"; // or "flex" depending on your CSS
    }

    // Fetch and display products
    var requests = wishlist.map(function (handle) {
      var productTileTemplateUrl = "/products/" + handle + "?view=wishlist";
      return fetch(productTileTemplateUrl).then(function (res) {
        if (res.status == 200) {
          return res.text();
        }
      });
    });

    Promise.all(requests).then(function (responses) {
      var wishlistProductCards = responses.join("");
      grid.innerHTML = wishlistProductCards;
      var buttons = grid.querySelectorAll("wishlist-item") || [];
      
      // Update the counter after loading products
      newWishlistObj.WishlistItemCounter();
    });
    
  } else {
    // Wishlist is empty - show empty message and hide grid
    if (wishlistExistBtn) {
      wishlistExistBtn.classList.remove("wishlist_exists");
    }
    
    grid.style.display = "none";
    
    // Hide the wishlist heading when empty
    // if (wishlistHeading) {
    //   wishlistHeading.style.display = "none";
    // }
    
    if (emptyList) {
      emptyList.style.display = "flex";
    }

    // Clear the grid content
    grid.innerHTML = "";
    
    // Update counter to show 0
    newWishlistObj.WishlistItemCounter();
  }
};